import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgStatusFlag = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="m12.36 6 .4 2H18v6h-3.36l-.4-2H7V6h5.36Zm1.8-1.196A1 1 0 0 0 13.18 4H6a1 1 0 0 0-1 1v15a1 1 0 1 0 2 0v-6h5.6l.24 1.196a1 1 0 0 0 .98.804H19a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-4.6l-.24-1.196Z" />
  )
export default SvgStatusFlag
